module.exports = "/img/_/_/_/assets/images/creeper/book/common//15.jpg?10b1bb4ac560b18f8ae4eda09f48f7c0";